import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class MonthlyDrActivityConfiguration extends ReportSectionConfigurationBase {
  typeName = 'MonthlyDrActivityConfiguration';
  nodataLocalizationKeyName = 'bnyMonthlyDrActivity';
  readonly reportSection = ReportSection.MonthlyDrActivity;
  readonly name = 'monthlyDrActivity';
  readonly displayName = 'Monthly DR Issue & Cancel Volume';
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_MonthlyDrActivity];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface MonthlyDrActivityData {
  [ReportViewModelSection.BnyManagementReport_MonthlyDrActivity]: MonthlyDrActivityInformation;
}

export interface MonthlyDrActivityInformation {
  drIssueAndCancelActivity: IssueCancelActivity[];
}

export interface IssueCancelActivity {
  date: Date;
  drsIssued: number;
  drsCancelled: number;
}
export interface MonthlyDrActivityInfo {
  issuedData: DrActivityData[];
  canceledData: DrActivityData[];
}

export interface DrActivityData {
  month: string;
  value: number;
}

export interface MonthlyDrData {
  month: string;
  issued: number;
  canceled: number;
}
